/**
 * @generated SignedSource<<4253e939901615eaf1c967ef1f687e5f>>
 * @relayHash 1986e4071459ef825acb60fb30fd9e0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c07d50afa6e876d6016581845c7c1f40166322035db1118041411e7c542f3603

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useTrashedSpaceRestoreSpaceMutation$variables = {
  spaceKey: string;
};
export type useTrashedSpaceRestoreSpaceMutation$data = {
  readonly restoreSpace: {
    readonly success: boolean;
  } | null | undefined;
};
export type useTrashedSpaceRestoreSpaceMutation = {
  response: useTrashedSpaceRestoreSpaceMutation$data;
  variables: useTrashedSpaceRestoreSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "RestoreSpacePayload",
    "kind": "LinkedField",
    "name": "restoreSpace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTrashedSpaceRestoreSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrashedSpaceRestoreSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1986e4071459ef825acb60fb30fd9e0f",
    "id": "c07d50afa6e876d6016581845c7c1f40166322035db1118041411e7c542f3603",
    "metadata": {},
    "name": "useTrashedSpaceRestoreSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation useTrashedSpaceRestoreSpaceMutation($spaceKey:String!){restoreSpace(spaceKey:$spaceKey){success}}"
  }
};
})();

(node as any).hash = "81c7e77af145a944ec2ee17a6ddeb1af";

export default node;
